
import { Component, Mixins } from "vue-property-decorator";
import FormLogin from "./";
const Words: Dictionary = {
  error: "法人会員IDまたは法人会員パスワードに誤りがあります。",
  error2: "システムエラー",
  account: "法人会員ID",
  password: "法人会員パスワード",
  login: "法人会員ログイン",
};
@Component
export default class FormLoginJa extends Mixins(FormLogin) {
  private words = Words;
}
